import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import BillingPage from 'billing/pages/BillingPage.vue';

// path settings/subscription (settings/billing e da rota CLOUD do enterprise)
export const routes = [
  {
    path: frontendURL('accounts/:accountId/settings/subscription'),
    meta: {
      permissions: ['administrator'],
    },
    component: SettingsWrapper,
    props: {
      headerTitle: 'VINCTO_BILLING.TITLE',
      icon: 'credit-card-person',
      showNewButton: false,
    },
    children: [
      {
        path: '',
        name: 'vincto_billing_index',
        component: BillingPage,
        meta: {
          permissions: ['administrator'],
        },
      },
    ],
  },
];
